import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faHome } from '@fortawesome/free-solid-svg-icons';

const NotFoundPage: React.FC = () => {
  return (
    <div className="container py-5">
      <div className="text-center">
        <FontAwesomeIcon icon={faExclamationTriangle} style={{ fontSize: '4rem', color: 'var(--warning-color)' }} />
        <h1 className="mt-4">404 - Seite nicht gefunden</h1>
        <p className="mb-4">
          Die angeforderte Seite existiert leider nicht. Bitte überprüfen Sie die URL oder kehren Sie zur Startseite zurück.
        </p>
        <Link to="/" className="btn btn-primary">
          <FontAwesomeIcon icon={faHome} className="mr-2" /> Zur Startseite
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
